import {
  ProductTranslationModel,
  ProductTranslationTableModel,
  ConceptTranslationModel,
  TranslationModelBase,
  TranslationTableModelBase,
  ConceptTranslationTableModel,
  ConceptTranslation
} from './translationsCard.model'
import { LanguageModel } from '../../../api/Argentia/model/contracts'
import { SelectOption } from '@globaleris/ui.library'
import { Concept, EditConceptModel } from '../../../api/Argentia/endpoints/concepts/model/concepts'

// export const translationsToTranslationTableModelMapper = (
//   translations: ProductTranslationModel[]
// ): ProductTranslationTableModel[] => {
//   return translations.map(translation => translationToTranslationTableModelMapper(translation))
// }

// export const translationToTranslationTableModelMapper = (
//   translation: ProductTranslationModel
// ): ProductTranslationTableModel => {
//   return {
//     id: translation.id!,
//     productId: translation.productId!,
//     language: translation.language,
//     description: translation.description,
//     default: translation.default,
//     notDefault: !translation.default,
//     tempId: translation.tempId,
//     actions: translation.actions
//   }
// }

// export const translationsTableModelMapperToTranslationsModel = (
//   tableTranslations: ProductTranslationTableModel[]
// ): ProductTranslationModel[] => {
//   return tableTranslations.map(translation => translationToTranslationTableModelMapper(translation))
// }

// export const translationTableModelMapperToTranslationsModel = (
//   tableTranslation: ProductTranslationTableModel
// ): ProductTranslationModel => {
//   return {
//     id: tableTranslation.id,
//     productId: tableTranslation.productId,
//     language: tableTranslation.language,
//     description: tableTranslation.description,
//     default: tableTranslation.default,
//     tempId: tableTranslation.tempId,
//     actions: tableTranslation.actions
//   }
// }

// export const mapTranslationsToTranslationsModel = (
//   translations: ProductTranslation[] | undefined
// ): ProductTranslationModel[] => {
//   if (translations && translations.length > 0) {
//     return translations.map(
//       o =>
//         ({
//           id: o.id,
//           productId: o.productId,
//           language: o.language,
//           description: o.description,
//           default: o.default,
//           tempId: o.tempId,
//           actions: o.actions
//         }) as ProductTranslationModel
//     )
//   } else {
//     return []
//   }
// }

// export const mapConceptTranslationsToTranslationsModel = (
//   translations: ConceptTranslation[] | undefined
// ): ConceptTranslationModel[] => {
//   return translations ? translations.map(mapConceptTranslationToTableModelToTranslationModel) : []
// }

// export const mapConceptTranslationToTableModelToTranslationModel = (
//   translation: ConceptTranslation
// ) => {
//   return {
//     id: translation.id,
//     productId: translation.conceptId,
//     language: translation.language,
//     description: translation.description,
//     default: translation.default,
//     tempId: translation.tempId,
//     actions: translation.actions
//   }
// }

export const translationsToTranslationTableModelMapper = <
  T extends Omit<TranslationModelBase, 'entityId'>,
  U extends TranslationTableModelBase
>(
  translations: T[]
): U[] => {
  return translations.map(translation =>
    translationToTranslationTableModelMapper<T, U>(translation)
  )
}

export const translationToTranslationTableModelMapper = <
  T extends Omit<TranslationModelBase, 'entityId'>,
  U extends TranslationTableModelBase
>(
  translation: T
): U => {
  return {
    id: translation.id,
    // entityId: translation.entityId, // Mapping entityId
    language: translation.language,
    description: translation.description,
    default: translation.default,
    notDefault: !translation.default,
    tempId: translation.tempId,
    actions: translation.actions
  } as U
}

export const translationsTableModelMapperToTranslationsModel = <
  U extends TranslationTableModelBase,
  T extends TranslationModelBase
>(
  tableTranslations: U[]
): T[] => {
  return tableTranslations.map(translation =>
    translationTableModelMapperToTranslationsModel<U, T>(translation)
  )
}

export const translationTableModelMapperToTranslationsModel = <
  U extends TranslationTableModelBase,
  T extends TranslationModelBase
>(
  tableTranslation: U
): T => {
  return {
    id: tableTranslation.id,
    entityId: tableTranslation.entityId, // Mapping entityId
    language: tableTranslation.language,
    description: tableTranslation.description,
    default: tableTranslation.default,
    tempId: tableTranslation.tempId,
    actions: tableTranslation.actions
  } as T
}

export const mapTranslationsToTranslationsModel = <T extends TranslationModelBase>(
  translations: T[] | undefined
): T[] => {
  if (translations && translations.length > 0) {
    return translations.map(
      o =>
        ({
          id: o.id,
          entityId: o.entityId, // Mapping entityId
          language: o.language,
          description: o.description,
          default: o.default,
          tempId: o.tempId,
          actions: o.actions
        }) as T
    )
  } else {
    return []
  }
}

export const conceptTranslationsToTranslationTableModelMapper = (
  translations: ConceptTranslation[]
): ConceptTranslationTableModel[] => {
  return translations.map(translation => ({
    id: translation.id,
    entityId: translation.conceptId,
    conceptId: translation.conceptId,
    language: translation.language,
    description: translation.description,
    default: translation.default,
    notDefault: !translation.default,
    tempId: translation.tempId,
    actions: translation.actions
  }))
}

export const conceptTranslationTableModelMapperToConceptTranslationsModel = (
  tableTranslation: ConceptTranslationTableModel
): ConceptTranslationModel => {
  return {
    id: tableTranslation.id,
    conceptId: tableTranslation.conceptId,
    language: tableTranslation.language,
    description: tableTranslation.description,
    default: tableTranslation.default,
    tempId: tableTranslation.tempId,
    actions: tableTranslation.actions
  }
}

export const mapConceptToTranslationsModel = (
  concept: Concept | EditConceptModel
): ConceptTranslationModel[] => {
  if (concept.translations && concept.translations.length > 0) {
    return concept.translations.map(translation => ({
      id: translation.id,
      conceptId: concept.id,
      language: translation.language,
      description: translation.description,
      default: translation.default,
      tempId: translation.tempId,
      actions: translation.actions
    }))
  } else {
    return []
  }
}
